module.exports = __webpack_public_path__ + "kusamaproject/img/kpi.0305372d.png";